import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { WsContentApi } from 'api/ApiHelper';

export const useDeleteContentMutation = (contentId: number, options?: UseMutationOptions) =>
  useMutation({ mutationFn: () => WsContentApi.deleteContent(contentId), ...options });
